import { apiHttp, pickData, SuccessResponse } from 'shared/request'

export const signIn = (account: string) =>
    apiHttp
        .post<
            SuccessResponse<{
                access_token: string
            }>
        >('account/login', { account })
        .then(pickData)
